"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPaymentsCollectedReportResponse = exports.transformPaymentsCollectedReportData = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("../Error");
const Money_1 = require("../Money");
const PaymentsCollectedEntry_1 = require("./PaymentsCollectedEntry");
function transformPaymentsCollectedReportData({ currency_codes, clientids, start_date, end_date, download_token, payment_methods, payments, totals, }) {
    return {
        currencyCodes: currency_codes,
        clientIds: clientids,
        startDate: start_date,
        endDate: end_date,
        downloadToken: download_token,
        paymentMethods: payment_methods,
        payments: payments && (0, PaymentsCollectedEntry_1.transformPaymentsCollectedEntryResponeList)(payments),
        totals: totals && totals.map((moneyResponse) => (0, Money_1.transformMoneyParsedResponse)(moneyResponse)),
    };
}
exports.transformPaymentsCollectedReportData = transformPaymentsCollectedReportData;
/**
 * Parses JSON PaymentsCollectedReport response and converts to @PaymentsCollectedReport model
 * @param data representing JSON response
 * @returns @PaymentsCollectedReport | @Error
 */
function transformPaymentsCollectedReportResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { response: { result }, } = response;
    const { payments_collected } = result;
    return transformPaymentsCollectedReportData(payments_collected);
}
exports.transformPaymentsCollectedReportResponse = transformPaymentsCollectedReportResponse;
//# sourceMappingURL=PaymentsCollectedReport.js.map